import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { auth } from './firebase.config';
import { onAuthStateChanged } from 'firebase/auth';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom, BehaviorSubject } from 'rxjs';
import { AuthService } from './services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authservice: AuthService) {''

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Promise<boolean>{
    return new Promise((resolve) => {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          const jwtToken = await user.getIdToken();
          this.authservice.setUserToken(jwtToken, "google");
          this.authservice.setLoggedInUser(user.email);
          resolve(true); // User is signed in, allow access
        } else {
          this.authservice.setLoggedInUser(null);
          // Not logged in, redirect to login page with returnUrl
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
          resolve(false);
        }
      });
    });
  }
}
